import {MessageCodes} from "../Components/Output/MessageCodes";

const tsv = require('tsv')
const getProjectTitle = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Proj Title'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '')
        }
    }
}

const getProjectDescription = (text) => {
    const split = text.split('\n')
    const descriptions = []
    let isFind = false
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('BEGIN DESCRIPTION'))
        {
            isFind = true
            continue
        }


        if(line.includes('END DESCRIPTION'))
            break

        if(isFind)
            descriptions.push(line)
    }

    return descriptions;
}

const getGeometryTitle = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Geom Title'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '')
        }
    }
}

const getGeometryFile = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Geom File'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '')
        }
    }
}

const getFlowFile = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Flow File'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '')
        }
    }
}

const getPlanTitle = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Plan Title'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '')
        }
    }
}

const getPlanShortIdentifier = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Short Identifier'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '').trim()
        }
    }
}

const getPlanVersion = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Program Version') || line.includes('Version'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '').trim()
        }
    }
}

const getPlanDescription = (text) => {
    const split = text.split('\n')
    const descriptions = []
    let isFind = false
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('BEGIN DESCRIPTION'))
        {
            isFind = true
            continue
        }


        if(line.includes('END DESCRIPTION'))
            break

        if(isFind)
            descriptions.push(line)
    }

    return descriptions;
}

const getFlowTitle = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Flow Title'))
        {
            return  line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '')
        }
    }
}

const getFlowProfiles = (text) => {
    const split = text.split('\n')
    for(let i=0; i<split.length; i++)
    {
        const line = split[i]
        if(line.includes('Profile Names'))
        {
            const profiles = line.split('=')[1].replaceAll('\\r', '').replaceAll('\\n', '');
            return profiles.split(',').map(x => x.trim())
        }
    }
    return []
}


const checkColumns = (text) => {
    if(!text)
        return []

    const data = tsv.parse(text)
    let columns = []
    data.forEach(x => {
        columns = [...columns, ...Object.keys(x)]
    })

    columns = [...new Set(columns)]
    let def = ['Prof Delta WS', 'Conv. Ratio', 'Sta W.S. Lft', 'Sta W.S. Rgt', 'Vel Head', 'Headloss', 'W.S. Elev']
    let filtered = def.filter(x => !columns.includes(x))

    return filtered
}

const parseAllOutputProfiles = (text) => {
    const data = tsv.parse(text);
    const filteredData = []

    //filter empty data and culvert
    data.forEach((x, index) => {
        if(index === 0)
            return

        const keys = Object.keys(x)
        let empty = 0
        for(let i=0; i<keys.length; i++)
        {
            const key = keys[i]
            if(x[key] === 'Culvert')
            {
                continue
            }

            if(!x[key] || x[key] === '')
                empty++
        }

        if(empty <= keys.length/2)
        {
            filteredData.push(x)
        }
    })

    const plans = []

    filteredData.forEach(row => {
        let plan = plans.find(x => x.Plan === row.Plan);
        if(!plan)
        {
            plan = {
                Plan: row.Plan,
                profiles: []
            }
            plans.push(plan)
        }

        if(plan)
        {
            plan.profiles.push({
                Profile: row.Profile,
                data: {
                    Plan: row.Plan,
                    Reach: row.Reach,
                    CrossSection: row['River Sta']?.toString(),
                    Profile: row['Profile'],
                    WSElev: parseFloat(row['W.S. Elev']),
                    ProfDeltaWS: parseFloat(row['Prof Delta WS']),
                    StaWSLft: parseFloat(row['Sta W.S. Lft']),
                    StaWSRgt: parseFloat(row['Sta W.S. Rgt']),
                    VelHead: parseFloat(row['Vel Head']),
                    ConvRatio: parseFloat(row['Conv. Ratio']),
                    Headloss: parseFloat(row['Headloss']),
                }
            })
        }
    })

    return plans
}

const mapProfiles = (plan, mapData) => {
    if(!plan)
        return

    const outputs = []

    plan.profiles?.forEach(row => {
        const emptyItem = {
            Plan: plan.Plan,
            Reach: row.data.Reach,
            CrossSection: row.data.CrossSection,
            Profile: null,
            WSElev: null,
            ProfDeltaWS: null,
            StaWSLft: null,
            StaWSRgt: null,
            VelHead: null,
            ConvRatio: null,
            Headloss: null,
        }

        let item = outputs.find(x => x.CrossSection === row.data.CrossSection)
        if(!item)
        {
            item = {
                Reach: row.data.Reach,
                CrossSection: row.data.CrossSection,
                FW: emptyItem,
                YR2: emptyItem,
                YR10: emptyItem,
                YR25: emptyItem,
                YR50: emptyItem,
                YR100: emptyItem,
                YR500: emptyItem,
                FUT10: emptyItem,
                FUT20: emptyItem,
                FUT35: emptyItem,
                FUTULT: emptyItem,
            }
            outputs.push(item)
        }
        const map = mapData.find(x => x.select.toString() === row.Profile.toString())
        if(map && map.target)
        {
            item[map.target] = {
                ...row.data,
                Profile: map.target
            }
        }
    })

    return outputs;
}

const findMinMax = (data, type) => {
    const min = type === 'min' ? Math.min(...data.map(x => parseFloat(x))) : Math.max(...data.map(x => parseFloat(x)))
    const val = data.find(x => parseFloat(x) === min)

    if(val?.toString().includes('BR U')) {
        let br_d = data.find(x => x === val.replaceAll('BR U', 'BR D'))
        if(br_d)
            return br_d
    }

    return val ?? -1
}

const getCSList = (operations) => {
    const cs = []
    for (const operation of operations) {
        for (const child of operation.children) {
            const result = child.result?.result
            if(result) {
                for (const res of result) {
                    for (const row of res.data) {
                        cs.push(row.cross_section.toString())
                    }
                }
            }
        }
    }

    cs.sort(function(a, b) {
        return parseFloat(b) - parseFloat(a);
    });

    return Array.from(new Set([...cs])).map(x => ({name: x, value: parseFloat(x)}))
}

const inFilter = ({us, ds, cs_name}) => {
    if(!us && !ds) {
        return false
    }

    let res = true
    if(ds && parseFloat(cs_name) < parseFloat(ds)) {
        res = false
    }
    if(us && parseFloat(cs_name) > parseFloat(us))
        res = false

    return res
}

const filterResult = ({operations, filter, direction}) => {
    for (const operation of (operations || [])) {
        for (const child of (operation?.children || [])) {
            for (const result of (child?.result?.result || [])) {
                if(!result.originalData)
                    result.originalData = [...(result?.data || [])]

                if(!filter.us && !filter.ds)
                    result.data = [...result.originalData]
                else if(filter.filterType === 'filter') {
                    result.data = result.originalData.filter(x => inFilter({us: filter.us, ds: filter.ds, cs_name: x.cross_section}))
                }
                else if(filter.filterType === 'highlight' || filter.filterType === 'clear') {
                    result.data = [...result.originalData]
                }

                // result.data = result.data.reverse()
            }
        }
    }

    return operations
}

const parseCSListFromGeoFile = ({geoFile}) => {
    const lines = geoFile?.split('\n')?.filter(x => x.includes('Type RM Length'))
    const cs_list = []
    for (const line of lines) {
        if(line) {
            const split = line.split('=')
            if(split.length > 1)
            {
                const props = split[1]?.split(',')?.map(x => x?.trim())
                if(props.length >= 2)
                {
                    cs_list.push({
                        name: props[1],
                        value: parseFloat(props[1])
                    })
                }
            }
        }
    }
    return cs_list
}

const calcWSEL = ({
    C11,
    C1,
    C2,
    C3,
    C4,
    C5,
    C6,
    C7,
    C12,
    C13,
    C20,
    C21,
    minCS,
    maxCS,
    csList,
                  }) => {

    let section_list = [
        C1,
        C2,
        C3,
        C4,
        C5,
        C6,
        C7,
        C12,
        C13,
        C20,
        C21,
    ]

    const cross_sections = []
    let min_section = -1
    let max_section = -1

    section_list.forEach(x => {
        x?.result?.result?.forEach(y => {
            y?.data?.forEach(z => {
                if(Object.keys(z)?.includes('cross_section')) {
                    cross_sections.push({name: z['cross_section'], title: x.title})
                }
            })
        })
    })

    min_section = findMinMax(cross_sections.map(x => x.name), 'min')
    max_section = findMinMax(cross_sections.map(x => x.name), 'max')

    let wsel_sections = []

    C11?.result?.result?.forEach(x => {
        if(x?.error_id === MessageCodes.Compare.TWSEL000.error_id)
            return

        x?.data?.forEach((y, idx) => {

            if(idx === 0 && parseFloat(y['diff']) === 0) {
                return
            }

            if(idx === x?.data?.length-1 && parseFloat(y['diff']) === 0) {
                return
            }

            if(Object.keys(y)?.includes('cross_section')) {
                wsel_sections.push(y['cross_section'])
            }
        })
    })

    if(wsel_sections.length > 0 && wsel_sections[0] === 0)
        wsel_sections = wsel_sections.splice(0, 1)

    if(wsel_sections.length > 0 && wsel_sections[wsel_sections.length-1] === 0)
        wsel_sections = wsel_sections.splice(wsel_sections.length-1, 1)

    const wsel_min = findMinMax(wsel_sections, 'min');
    const wsel_max = findMinMax(wsel_sections, 'max');

    const project_min = findMinMax([wsel_min, min_section].filter(x => x && x !== -1), 'min')
    const project_max = findMinMax([wsel_max, max_section].filter(x =>  x && x !== -1), 'max')

    const bound_min = csList.filter(x => x.value < project_min).map(x => x.value);
    const bound_max = csList.filter(x => x.value > project_max).map(x => x.value);

    const boundary_min = bound_min.length > 0 ? Math.max(...bound_min) : project_min;
    let boundary_max = bound_max.length > 0 ? Math.min(...bound_max) : project_max;

    if(wsel_max !== -1)
        cross_sections.push({name: wsel_max, title: '100yr WSEL'})
    if(wsel_min !== -1)
        cross_sections.push({name: wsel_min, title: '100yr WSEL'})

    return {
        affected_reach_min: wsel_min,
        affected_reach_max: wsel_max,
        revised_reach_min: min_section,
        revised_reach_max: max_section,
        project_min: project_min,
        project_max: project_max,
        boundary_min,
        boundary_max,
        topics: cross_sections,
        minCS,
        maxCS
    }
}

const isUndefined = (val, noneText) => {
    if(val === 0)
        return val

    if(!val)
        return noneText || '-'

    return val
}

const getUSDS = ({us, ds, csList}) => {
    let us_val = null
    let ds_val = null

    if(us) {
        us_val = csList.find(x => parseFloat(x.name) === parseFloat(us))
        if(!us_val) {
            const filtered = csList.filter(x => x.name <= parseFloat(us)).sort((a,b) => a - b)
            us_val = filtered[0]
        }
    }

    if(ds) {
        ds_val = csList.find(x => parseFloat(x.name) === parseFloat(ds))
        if(!ds_val) {
            const filtered = csList.filter(x => parseFloat(x.name) >= parseFloat(ds)).sort((a,b) => a - b)
            ds_val = filtered[0]
        }
    }

    return {us_val, ds_val}
}

const HecRasHelper = {
    getProjectTitle,
    getProjectDescription,
    getFlowTitle,
    getFlowProfiles,
    getGeometryTitle,
    getPlanTitle,
    getGeometryFile,
    getFlowFile,
    parseAllOutputProfiles,
    mapProfiles,
    getPlanShortIdentifier,
    getPlanVersion,
    checkColumns,
    calcWSEL,
    isUndefined,
    getCSList,
    filterResult,
    inFilter,
    getUSDS,
    parseCSListFromGeoFile
}

export default HecRasHelper
